import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {DatePipe} from '@angular/common';
import { Alert } from '../../utilities';
import { GlobalQuestionService } from '../../services/global-question.service';

@Component({
    selector: 'app-question-multiple-date-picker',
    templateUrl: './question-multiple-date-picker.component.html',
    styleUrls: ['./question-multiple-date-picker.component.scss'],
    standalone: false
})
export class QuestionMultipleDatePickerComponent implements OnInit, OnChanges {

  @Input() numberMonths = 2;
  @Input() dateFormat = 'dd/MM/yyyy';
  @Input() startMinDate: any;
  @Input() startMaxDate: any;
  @Input() endMinDate: any;
  @Input() endMaxDate: any;
  @Input() category = 3;
  @Input() question: Question;
  @Input() startInitialDate = new Date();
  @Input() endInitialDate = new Date();
  @Input() showOtherMonths = true;
  @Input() displayInline = false;
  @Input() showLabel = true;
  @Input() showIcon = true;
  @Input() startLabel = 'Start';
  @Input() endLabel = 'End';
  @Output() questionAnswer = new EventEmitter<any>();
  parameters: any;
  date_1 = '';
  date_2 = '';

  constructor(private datePipe: DatePipe, private questionService: GlobalQuestionService) { }

  ngOnInit(): void {
    try {
      let d = JSON.parse(this.question.formated);
      this.date_1 = d.start;
      this.date_2 = d.end;
      this.startInitialDate = new Date(this.date_1);
      this.endInitialDate = new Date(this.date_2);
      console.log(d)
    }
    catch (e) { }
    if (this.question?.parameter) {
      this.parameters = JSON.parse(this.question?.parameter);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    
    if (changes?.question?.currentValue) {
      this.question = changes?.question?.currentValue;
    }
    if (changes?.numberMonths?.currentValue) {
      this.numberMonths = changes?.numberMonths?.currentValue;
    }
    if (changes?.dateFormat?.currentValue) {
      this.dateFormat = changes?.dateFormat?.currentValue;
    }
    if (changes?.startMinDate?.currentValue) {
      this.startMinDate = changes?.startMinDate?.currentValue;
      this.startInitialDate = this.startMinDate;
    }
    if (changes?.startMaxDate?.currentValue) {
      this.startMaxDate = changes?.startMaxDate?.currentValue;
    }
    if (changes?.endMinDate?.currentValue) {
      this.endMinDate = changes?.endMinDate?.currentValue;
    }
    if (changes?.endMaxDate?.currentValue) {
      this.endMaxDate = changes?.endMaxDate?.currentValue;
    }
    if (changes?.category?.currentValue) {
      this.category = changes?.category?.currentValue;
    }
    if (changes?.startInitialDate?.currentValue) {
      this.startInitialDate = changes?.startInitialDate?.currentValue;
      if (this.date_1){
        this.startInitialDate = new Date(this.date_1);
      }
    }
    if (changes?.endInitialDate?.currentValue) {
      this.endInitialDate = changes?.endInitialDate?.currentValue;
      if (this.date_2){
        this.endInitialDate = new Date(this.date_2);
      }
    }
    if (changes?.showOtherMonths?.currentValue) {
      this.showOtherMonths = changes?.showOtherMonths?.currentValue;
    }
    if (changes?.displayInline?.currentValue) {
      this.displayInline = changes?.displayInline?.currentValue;
    }
    if (changes?.showLabel?.currentValue) {
      this.showLabel = changes?.showLabel?.currentValue;
    }
    
  }

  onDate1Change(value: any): void {
    const questionAnswer = JSON.parse(JSON.stringify(value));
    const newDate = this.date_1;

    if (questionAnswer?.answer) {
      this.date_1 = questionAnswer?.answer;
    } else {
      this.date_1 = questionAnswer;
    }
    
    if (this.date_2 == '') {
      this.addOneDayToDateDefault();
    }
    
    //if (newDate !== this.date_1) {
      this.submitAnswer();
   // }

  }

  onDate2Change(value: any): void {
    const questionAnswer = JSON.parse(JSON.stringify(value));
    const newDate = this.date_2;
    //if (this.date_2 == '') {
      if (questionAnswer?.answer) {
        this.date_2 = questionAnswer?.answer;
      } else {
        this.date_2 = questionAnswer;
      }
    //}
    if (new Date(this.date_1) > new Date(this.date_2)) {
      Alert("End date cannot be less than start date");
      this.question.answer = '';
      this.questionAnswer.emit(this.question);
      return;
    }
    //this.endInitialDate = new Date(this.date_2);
    //if (newDate !== this.date_2) {
      this.submitAnswer();
    //}
  }

  submitAnswer(): void {
    
    if (this.date_1 && this.date_2) {
      if (new Date(this.date_1) > new Date(this.date_2)) {
        return;
      }
      const answer = {
        start: this.date_1,
        end: this.date_2
      };
      
      if (this.question) {
        this.question.answer = JSON.stringify(answer);
        this.questionAnswer.emit(this.question);
      } else {
        this.questionAnswer.emit(answer);
      }
    }
  }

  addOneDayToDateDefault(): void {
    const startDate = new Date(this.date_1);
    const newStartDate = startDate.setDate(startDate.getDate() + 1);
    this.endMinDate = new Date(newStartDate);
    this.endMaxDate = null;
    this.endInitialDate = new Date(newStartDate);
    this.date_2 = this.datePipe.transform(this.endInitialDate, this.dateFormat);
  }

}
